/**
 * VANGUARD_ITEMS_INDICE_COMPACTO.json (schema_version 1), aportado por el staff.
 *
 * El índice asigna las celdas en orden estricto: lámina 1 fila 0 columna 0, luego columna 1… 8 por fila,
 * 64 por lámina. Se guarda como rangos de IDs por sección en ese mismo orden; la posición de cada ID se
 * calcula con su orden (sheet = ⌊i/64⌋+1, row = ⌊(i mod 64)/8⌋, column = i mod 8).
 * `indexSpotChecks` contiene coordenadas copiadas literalmente del JSON; el panel del staff verifica que
 * el cálculo coincide con ellas.
 *
 * Correspondencia numérica por ID (section * 512 + índice local). Revisión visual: solo muestra.
 */
export const indexSchema = { version: 1, totalItems: 904, sheets: 15, grid: 8, declaredSheetPx: 2048, declaredCellPx: 256 }

type Range = [number, number]
export const itemSpriteRanges: [number, Range[]][] = [
  [0, [[0, 28], [31, 35]]],
  [1, [[0, 8]]],
  [2, [[0, 18]]],
  [3, [[0, 11]]],
  [4, [[0, 24]]],
  [5, [[0, 19], [21, 23], [30, 31], [33, 34], [36, 36]]],
  [6, [[0, 21]]],
  [7, [[0, 14], [16, 19], [21, 22], [24, 31], [33, 36], [38, 46], [49, 53], [59, 70], [72, 73], [222, 224], [226, 226], [229, 229]]],
  [8, [[0, 53], [59, 73], [221, 227], [229, 230], [233, 233]]],
  [9, [[0, 53], [59, 73], [221, 227], [229, 230], [233, 233]]],
  [10, [[0, 53], [62, 71], [221, 226], [229, 230], [233, 233]]],
  [11, [[0, 53], [59, 73], [221, 227], [229, 230], [233, 233]]],
  [12, [[0, 19], [21, 24], [30, 50], [60, 65], [70, 72], [100, 143]]],
  [13, [[0, 5], [7, 18], [21, 76], [80, 82], [93, 94], [103, 107], [109, 116], [121, 130], [132, 132], [134, 134]]],
  [14, [[0, 26], [28, 29], [31, 35], [41, 54], [58, 68], [72, 93], [95, 124], [134, 163]]],
  [15, [[0, 24], [26, 36]]],
]

/** Copiadas literalmente del JSON: casos de prueba y bordes de lámina. */
export const indexSpotChecks: { id: string; label: string; sheet: number; column: number; row: number }[] = [
  { id: '7,1', label: 'Dragon Helm', sheet: 3, column: 6, row: 2 },
  { id: '0,0', label: 'Kris', sheet: 1, column: 0, row: 0 },
  { id: '15,8', label: 'Scroll of Evil Spirit', sheet: 14, column: 4, row: 5 },
  { id: '14,13', label: 'Jewel of Bless', sheet: 12, column: 4, row: 4 },
  { id: '3,2', label: 'primera celda de la lámina 2', sheet: 2, column: 0, row: 0 },
  { id: '12,70', label: 'primera celda de la lámina 10', sheet: 10, column: 0, row: 0 },
  { id: '15,36', label: 'última celda del índice', sheet: 15, column: 7, row: 0 },
]

export const missingSpriteIds = ['4,25', '4,26', '7,221', '7,227', '7,233', '12,26', '13,19', '13,20', '13,83', '13,84', '13,85', '13,86', '13,87', '13,88', '13,89', '13,90', '13,91', '13,92', '13,95', '13,96', '13,117', '13,118', '13,119', '13,120', '13,131', '13,133', '14,55', '14,56', '14,57', '14,125', '14,169', '14,244', '14,245', '14,246', '14,247', '14,248', '14,249', '14,250', '14,251', '14,252']

export const excludedSpriteIds = ['13,135', '13,136', '13,137', '13,138', '13,139', '13,140', '13,141', '13,142', '13,143', '13,144', '14,126', '14,127', '14,128', '14,129', '14,130', '14,131', '14,132']
